<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <table class="table table-sm table-striped table-hover table-bordered">
      <thead>
      <tr>
        <th class="text-center">
          Nombre
        </th>
        <th class="text-center">Acciones</th>
      </tr>
      </thead>
      <tbody>
      <template v-for="autorizacion in autorizaciones">

        <tr v-if="autorizacion.idEmpleado === getIdEmpleadoLogueado" :key="autorizaciones.indexOf(autorizacion)">
          <td class="text-center">{{ autorizacion.nombreEmpleado }}</td>
          <td v-if="autorizacion.autorizado === true">
            <p class="text-info text-center">
              Movimiento autorizado
            </p>
          </td>
          <td v-else align="center">
            <b-button-group>
              <b-button
                  v-if="$localStorageService.can('MV_autorizar')"
                  v-on:click="autorizarMovimiento(autorizacion.idMovimiento,autorizacion.idEmpleado)"
                  variant="success"
                  size="sm"
              > Autorizar
              </b-button>
              <b-button
                  v-if="$localStorageService.can('MV_ch_estatus_cancelado')"
                  v-on:click="cambiarEstatusCancelado(autorizacion.idMovimiento)"
                  variant="warning"
                  size="sm"
              > Cancelar
              </b-button>
            </b-button-group>
          </td>

        </tr>
        <tr v-else :key="autorizaciones.indexOf(autorizacion)">
          <td class="text-center">{{ autorizacion.nombreEmpleado }}</td>
          <td class="text-center">{{ autorizacion.autorizado === true ? 'Autorizado' : 'No autorizado' }}</td>

        </tr>
      </template>

      </tbody>
    </table>

  </div>
</template>

<script>
import {MovimientoService} from "../../../apiServices/movimiento/MovimientoService";

export default {
  name: "AutorizarMovimiento",
  props: {
    autorizaciones: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    movimientoService: new MovimientoService(),
  }),
  methods: {
    autorizarMovimiento(idMovimiento, idEmpleado) {
      this.movimientoService.autorizarMovimiento(idMovimiento, idEmpleado);
      this.$root.$emit('reload-traspasos','force')
      this.$root.$emit('reload-movimientos','force')
      this.$root.$emit('bv::hide::modal','autorizar-'+idMovimiento)
    },
    cambiarEstatusCancelado(idMovimiento){
      this.movimientoService.cambiarEstatusCancelado(idMovimiento);
      this.$root.$emit('reload-traspasos','force')
      this.$root.$emit('reload-movimientos','force')
      this.$root.$emit('bv::hide::modal','autorizar-'+idMovimiento)
    }
  },
  computed: {
    getIdEmpleadoLogueado() {
      return this.$localStorageService.getIdEmpleado()
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  }
}
</script>

<style scoped>

</style>